var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.available)?_c('div',{style:({
    position: "relative",
    backgroundImage: ("url(" + (_vm.preview.previewMask.src) + ")"),
    width: ((_vm.previewWidth * _vm.scale) + "px"),
    height: ((_vm.previewHeight * _vm.scale) + "px"),
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
  })},[_c('div',{staticClass:"mask",style:(_vm.styleMask)},[_c('div',{staticClass:"mask-matrix mask-matrix--image",style:(_vm.styleStamp)})]),_c('div',{staticClass:"mask-matrix mask-matrix__border",style:(_vm.styleStamp)}),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }